define(['ko', '_', 'search/price', 'text!./product-tile.html', 'bindings/numeric'], function (ko, _, priceViewModel, htmlString) {
    function ProductTile(params) {
        var self = this;
        var product = params.product;
        self.title = product.title;
        self.brand = product.brand;
        self.id = product.id;
        self.categoryId = product.category;
        self.categories = product.categories;
        self.price = product.price !== null ? new priceViewModel(product.price) : null;
        self.quantity = ko.observable(self.price !== null ? parseInt(self.price.minOrderQty, 10) : 1);
        self.instanceCount = product.instanceCount;
        self.thumbnail = product.thumbnail;
        self.standards = product.standards;
        self.highlight = product.highlight;
        self.firstSku = product.firstSku;
        self.stock = product.stock !== null ? product.stock : 0;
        self.properties = product.properties;
        self.canCheckoutFreeItems = product.price != null && product.price.canCheckoutFreeItems;

        self.isFavorite = ko.observable(params.isFavorite);
        self.isFavoriteLoading = ko.observable(false);
        self.isAddToCartLoading = ko.observable(false);
        self.isAddedToCart = ko.observable(false);
        /**
         * Display/start the cart check animation
         * @param finishAnimation <img.icon-checkcart> element
         */
        self.finishLoading = function (finishAnimation) {
            // restart the .SVG animation by appending a random hash
            finishAnimation.src = finishAnimation.src + '#' + Math.random();
            self.isAddedToCart(true);
            // reset to default button after 750ms
            _.delay(function() {
                self.isAddedToCart(false);
            }, 750);
        };
        
        self.slug = product.slug;
        
        self.categoryText = ko.pureComputed(function() {
            if(self.categories !== null && !_.isEmpty(self.categories)) {
                return self.categories[0].name;
            }
            return null;
        });
        self.categorySlug = ko.pureComputed(function() {
            if(self.categories !== null && !_.isEmpty(self.categories)) {
                var catUrl = "/categories";
                _.forEach(_.reverse(self.categories), (cat, i) => {
                    catUrl += "/" + cat.slug;
                });
                return catUrl;
            }
            return null; 
        });

        // todo: separate viewmodel with computed prop
        self.displayStandards = function (standard) {
            return _.join(
                _.map(_.filter(standard.values, (val) => !_.isNull(val.value)), (val) =>{
                    if(_.isEmpty(val.value)) {
                        return val.name;    
                    }
                    return val.name + ': ' + val.value})
                , ' | ');
        };
        
        self.increaseQty = function() {
            self.quantity(self.quantity() + 1);
        };
        self.decreaseQty = function() {
            if(self.quantity() <= 1) {
                return false;
            }
            self.quantity(self.quantity() - 1);
        };

        self.addToCart = function (event, data) {
            var finishAnimation = data.currentTarget.querySelector('.icon-checkcart');
            self.isAddToCartLoading(true);
            var url = '/internal-api/add-to-cart?sku=' + self.firstSku + '&qty=' + self.quantity();
            fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
            })
                .then(response => response.json())
                .then(data => {
                    var cartCounter = document.getElementById('header-shopping-cart-quantity');
                    cartCounter.innerText = _.sumBy(data.items, 'quantity');
                    var cartAmount = document.getElementById('header-shopping-cart-amount');
                    cartAmount.innerText = new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(data.total);
                })
                .finally(function () {
                    self.isAddToCartLoading(false);
                    self.finishLoading(finishAnimation);
                });
        };

        self.addToFavorites = function () {
            self.isFavoriteLoading(true);
            var url = '/internal-api/add-to-favorites?sku=' + self.firstSku;
            fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
            })
                .then(response => response.json())
                .then(data => {
                    if (_.isArray(data)) {
                        self.isFavorite(_.includes(data, self.firstSku));
                    }
                })
                .finally(function () {
                    console.log('klaar met favorites request');
                    self.isFavoriteLoading(false);
                });
        }
    }

    return {viewModel: ProductTile, template: htmlString};
});
